import React from 'react';
import { Navigate } from 'react-router-dom';

import { BillingLayout } from '../components/layout/BillingLayout';
import { ROUTES } from '../constants/routes';
import BillingReportsPage from '../pages/Billing/BillingReports';
import BillingSettingsPage from '../pages/Billing/BillingSettings';
import ManualPaymentsPage from '../pages/Billing/ManualPayments';
import Subscriptions from '../pages/Subscriptions/Subscriptions';
import DiscountCodes from '../pages/DiscountCodes/DiscountCodes';

/** Redirects /billing to the unified billing page (default billing page) */
export const BillingRedirect = () => (
  <Navigate to={ROUTES.BILLING_UNIFIED} replace />
);

/** Billing page wrappers - add tab bar navigation */
export const BillingReportsWithLayout = () => (
  <BillingLayout>
    <BillingReportsPage />
  </BillingLayout>
);

export const BillingSettingsWithLayout = () => (
  <BillingLayout>
    <BillingSettingsPage />
  </BillingLayout>
);

export const ManualPaymentsWithLayout = () => (
  <BillingLayout>
    <ManualPaymentsPage />
  </BillingLayout>
);

export const SubscriptionsWithLayout = () => (
  <BillingLayout>
    <Subscriptions />
  </BillingLayout>
);

export const DiscountCodesWithLayout = () => (
  <BillingLayout>
    <DiscountCodes />
  </BillingLayout>
);
